module.exports = __webpack_public_path__ + "static/img/icon_account.43e411a8.svg";